import React, { useState } from "react";
import { Modal, Box, Button } from "@mui/material";
import "./routeModal.css";
import BootstrapTooltip from "./tooltip";

const RouteModal = ({ onOpen, onClose, userRoute, setUserRoute, userUpdate, currentUser }) => {
  const [routeOrder, setRouteOrder] = useState(userRoute);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isRouteChanged, setIsRouteChanged] = useState(false);

  const handleDragStart = (index) => (event) => {
    event.dataTransfer.setData("text/plain", index);
  };

  const handleDrop = (targetIndex) => (event) => {
    event.preventDefault();
    const sourceIndex = Number(event.dataTransfer.getData("text/plain"));
    if (sourceIndex === targetIndex || sourceIndex < 0 || targetIndex < 0) return;
    const updated = [...routeOrder];
    const [moved] = updated.splice(sourceIndex, 1);
    updated.splice(targetIndex, 0, moved);
    setRouteOrder(updated);
    setHoveredIndex(null);
    setIsRouteChanged(JSON.stringify(updated) !== JSON.stringify(userRoute));
  };

  const handleDragOver = (index) => (event) => {
    event.preventDefault();
    setHoveredIndex(index);
  };

  const handleDragLeave = () => setHoveredIndex(null);

  const handleCloseModal = () => {
    setRouteOrder(userRoute);
    setIsRouteChanged(false);
    onClose(false);
  };

  const handleConfirm = () => {
    if (currentUser && currentUser.userId) {
      userUpdate({ route: routeOrder, userId: currentUser.userId }, true);
      setUserRoute(routeOrder);
    } else {
      userUpdate({ route: routeOrder });
    }
    onClose(false);
  };
  
  const toggleGeofenceState = (index) => {
    const updated = routeOrder.map((g, i) =>
      i === index ? { ...g, state: g.state === "activo" ? "omitido" : "activo" } : g
    );
    setRouteOrder(updated);
    setIsRouteChanged(true);
  };

  const handleAngleChange = (index) => (event) => {
    let value = event.target.value;
    if (value === "") value = null;
    else {
      value = Number(value);
      if (value < 0 || value > 360) return;
    }
    const updated = routeOrder.map((g, i) =>
      i === index ? { ...g, orientation: value } : g
    );
    setRouteOrder(updated);
    setIsRouteChanged(true);
  };

  const duplicateGeofence = (index) => {
    const current = routeOrder[index];
    const currentId = current.id;
    let updated = [...routeOrder];
    const sameIdCount = routeOrder.filter(r => r.id === currentId).length;

    if (sameIdCount > 1) {
      updated = updated.filter((item, i) => item.id !== currentId || i === index);
      updated = updated.map(item =>
        item.id === currentId ? { ...item, label: normalizeLabel(item.label) } : item
      );
      setRouteOrder(updated);
      setIsRouteChanged(true);
      return;
    }

    const baseName = normalizeLabel(current.label);
    const ida = { ...current, label: `${baseName} Ida` };
    const vuelta = { ...current, label: `${baseName} Vuelta` };
    updated.splice(index, 1, ida, vuelta);
    setRouteOrder(updated);
    setIsRouteChanged(true);
  };

  const normalizeLabel = (label) => {
    return label.replace(/\s+Ida$/, "").replace(/\s+Vuelta$/, "").trim();
  };

  return (
    <Modal open={onOpen} onClose={handleCloseModal}>
      <Box className="modal_box route_modal">
        <h2 style={{ textAlign: "center" }}>Modificar Ruta General</h2>

        <div style={{ display: 'flex', gap: '0.5rem', padding: '0 calc(0.5rem + 2px)' }}>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flex: 1 }}>Nombre</span>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flexBasis: '70px' }}>Orientación</span>
          <span style={{ fontSize: '0.75rem', fontStyle: 'italic', flexBasis: '100px', textAlign: 'center', marginRight: '3.7rem' }}>Estatus</span>
        </div>

        <div className="route_container">
          {routeOrder.length > 0 ? (
            <ul>
              {routeOrder.map((geofence, index) => (
                <li
                  key={`${geofence.id}-${index}`}
                  draggable
                  onDragStart={handleDragStart(index)}
                  onDragOver={handleDragOver(index)}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop(index)}
                  className={`${hoveredIndex === index ? "hovered" : ""} ${geofence.state === "omitido" ? "omitted" : ""}`}
                  style={{ display: 'flex', gap: '0.5rem' }}
                >
                  <span style={{ fontSize: "0.7rem", flex: 1 }}>{geofence.label}</span>
                  <input
                    type="number"
                    min={0}
                    max={360}
                    value={geofence.orientation ?? 0}
                    onChange={handleAngleChange(index)}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = Number(e.target.value);
                      if (val < 0 || val > 360) handleAngleChange(index)({ target: { value: "" } });
                    }}
                    style={{
                      width: '60px',
                      fontSize: '0.7rem',
                      padding: '2px',
                      flexBasis: '70px',
                    }}
                  />
                  <Button onClick={() => toggleGeofenceState(index)} style={{ fontSize: '0.7rem', flexBasis: '100px', }}>
                    {geofence.state === "activo" ? "Omitir" : "Activar"}
                  </Button>
                  {routeOrder.filter(r => r.id === geofence.id).length > 1 ?
                    <BootstrapTooltip
                      title={'Unificar'}
                    >

                      <Button
                        onClick={() => duplicateGeofence(index)}
                        style={{ minWidth: '32px' }}
                      >
                        <span className='material-symbols-rounded icon' style={{ fontSize: '18px', color: 'var(--color-danger)' }}>tab_close_inactive</span>
                      </Button>
                    </BootstrapTooltip>
                    :
                    <BootstrapTooltip
                      title={'Duplicar'}
                    >

                      <Button
                        onClick={() => duplicateGeofence(index)}
                        style={{ minWidth: '32px' }}
                      >
                        <span className='material-symbols-rounded icon' style={{ fontSize: '18px' }}>tab_inactive</span>
                      </Button>
                    </BootstrapTooltip>
                  }
                </li>
              ))}
            </ul>
          ) : (
            <span style={{ margin: "auto", fontStyle: "italic" }}>No hay una ruta definida.</span>
          )}
        </div>

        <Box className="button_container">
          <Button onClick={handleCloseModal} className="cancel_button">Cancelar</Button>
          <Button onClick={handleConfirm} className="accept_button" disabled={!isRouteChanged}>Confirmar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RouteModal;
